import apiClient from 'services/api';

type InquiryResponse = {
  inquiry: { sender_name: string; message: string; replied_at: string | null };
};

export const getInquiry = (token: string) =>
  apiClient.get<InquiryResponse>(`/public/reviews/inquiry/${token}`);

export const replyToInquiry = (token: string, reply: string) =>
  apiClient.post<{ message: string }>(
    `/public/reviews/inquiry/${token}/reply`,
    { reply },
  );
